'use client';
import { useState, useEffect } from 'react';
import "./style.css";

type Props = {
  label?: string;
  name?: string;
  value?: string;
  error?: string;
  className?: string;
  containerClassName?: string;
  onlyNumber?: boolean;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  rows?: number;
  cols?: number;
  autoResize?: boolean;
  onChange?: (value: string) => void;
};

const InputTextArea = ({ 
  label, 
  name, 
  value = '', 
  error, 
  className, 
  containerClassName,
  onlyNumber, 
  required, 
  maxLength, 
  disabled, 
  placeholder,
  rows = 5,
  cols = 30,
  autoResize = true,
  onChange 
}: Props) => {
  const [textareaValue, setTextareaValue] = useState(value);

  const handleValidation = (value: string) => {
    if (onlyNumber && !/^[0-9]*$/.test(value)) {
      return false;
    }
    return value;
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    const validatedValue = handleValidation(newValue);
    
    if (validatedValue !== false) {
      setTextareaValue(validatedValue);
      onChange && onChange(validatedValue);
    }
  };

  // Update internal state when value prop changes
  useEffect(() => {
    setTextareaValue(value);
  }, [value]);

  return (
    <div className={`input-textarea-container ${containerClassName || ''}`}>
      {label && (
        <label htmlFor={name} className={`input-textarea-label ${error ? 'error' : ''}`}>
          {label}
          {required && <span className="input-textarea-required"> *</span>}
        </label>
      )}
      <textarea
        id={name}
        className={`input-textarea-input ${error ? 'error' : ''} ${className || ''} ${disabled ? 'disabled' : ''}`}
        value={textareaValue}
        onChange={handleTextareaChange}
        maxLength={maxLength}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        cols={cols}
        style={{
          resize: autoResize ? 'vertical' : 'none'
        }}
      />
      {error && <small className="input-textarea-error">{error}</small>}
    </div>
  );
};

export default InputTextArea;
